// extracted by mini-css-extract-plugin
module.exports = {"metadata":"LessonDetails_metadata__Hgy5N","fade_in":"LessonDetails_fade_in__T_9In"};